import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import StadiumIcon from "@mui/icons-material/Stadium";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Button } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Modal from "@mui/material/Modal";
import HorizontalLinearStepper from "./Stepper";
import "./Edv.css";
import { PaisajeLuzSteps } from "../utils/tutorials/PaisajeLuzTutorial";
import { BernabeuSteps } from "../utils/tutorials/BernabeuTutorial";
import StarIcon from "@mui/icons-material/Star";
import HomeWork from "@mui/icons-material/HomeWork";
import TakeoutDiningIcon from "@mui/icons-material/TakeoutDining";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LogoutIcon from "@mui/icons-material/Logout";
import EngineeringIcon from "@mui/icons-material/Engineering";
import { redirect } from "react-router-dom";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import { CabalgataSteps } from "../utils/tutorials/CabalgataTutorial";
import { BailenSteps } from "../utils/tutorials/BailenTutorial";
import { RetiroSteps } from "../utils/tutorials/RetiroTutorial";
import { MNNSteps } from "../utils/tutorials/MadridNNTutorial";
import { SentimientoSteps } from "../utils/tutorials/SentimientoTutorial";
import { UrbanosSteps } from "../utils/tutorials/UrbanosTutorial";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import InventoryIcon from "@mui/icons-material/Inventory";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import { MaratonSteps } from "../utils/tutorials/MaratonTutorial";
import { MercamadridSteps } from "../utils/tutorials/MercamadridTutorial";
import ApartmentIcon from "@mui/icons-material/Apartment";
import { UrbanismoSteps } from "../utils/tutorials/UrbanismoTutorial";

// get token from session storage
function getUserInfo() {
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);

  return userToken;
}

function Edv(props) {
  const { containerWindow } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [iframeSrc, setIframeSrc] = React.useState("map/index.html");
  const iframeRef = React.useRef(null);
  const [showBackButton, setShowBackButton] = React.useState(false);
  const [lateralWidth, setLateralWidth] = React.useState(250);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    sessionStorage.removeItem("token");
    redirect("/");
    // force reload
    window.location.reload();
  };

  const getNameInitials = () => {
    const name = getUserInfo().name;
    const words = name.split(" ");
    switch (words.length) {
      case 0:
        return "";
      case 1:
        return words[0][0];
      case 2:
        return words[0][0] + words[1][0];
      case 3:
        return words[0][0] + words[1][0] + words[2][0];
      default:
        return null;
    }
  };

  const [useCaseSelected, setUseCaseSelected] = React.useState(null);
  const [modalOpen, setModalOpen] = React.useState(false);
  const useCases = [
    {
      id: 0,
      name: "Madrid Nuevo Norte",
      iframeSrc: "mnn",
      lat: 40.47871408842441,
      lon: -3.6845506974842777,
      height: 3000,
      icon: <HomeWork />,
      steps: MNNSteps,
    },
    {
      id: 1,
      name: "Puente de Bailen",
      iframeSrc: "bailen",
      lat: 40.41391139214992,
      lon: -3.7136350554302218,
      height: 1000,
      icon: <EngineeringIcon />,
      steps: BailenSteps,
    },
    {
      id: 2,
      name: "Media Maratón",
      iframeSrc: "maraton",
      lat: 40.430820658368916,
      lon: -3.695792922099286,
      height: 5605,
      icon: <DirectionsRunIcon />,
      steps: MaratonSteps,
    },
    {
      id: 3,
      name: "Inventario de Ciudad",
      iframeSrc: "trafico",
      lat: 40.430820658368916,
      lon: -3.695792922099286,
      height: 6500,
      icon: <InventoryIcon />,
      steps: RetiroSteps,
    },
    {
      id: 4,
      name: "Mercamadrid",
      iframeSrc: "mercamadrid",
      lat: 40.360269584990014,
      lon: -3.6607179350571055,
      height: 1500,
      icon: <LocalGroceryStoreIcon />,
      steps: MercamadridSteps,
    },
    {
      id: 5,
      name: "Cabalgata de Reyes",
      iframeSrc: "cabalgata",
      lat: 40.430820658368916,
      lon: -3.695792922099286,
      height: 5605,
      icon: <StarIcon />,
      steps: CabalgataSteps,
    },
    {
      id: 6,
      name: "EUI Casa de Campo",
      iframeSrc: "urbanos",
      lat: 40.428401873582054,
      lon: -3.7464259560740274,
      height: 6000,
      icon: <TakeoutDiningIcon />,
      steps: UrbanosSteps,
    },
    {
      id: 7,
      name: "Paisaje de la Luz",
      iframeSrc: "paisajeluz",
      lat: 40.41479981408173,
      lon: -3.68411630308208,
      height: 3112,
      icon: <LightbulbIcon />,
      steps: PaisajeLuzSteps,
    },
    {
      id: 8,
      name: "Santiago Bernabeu",
      iframeSrc: "bernabeu",
      lat: 40.45309799353097,
      lon: -3.6882820101043636,
      height: 2000,
      icon: <StadiumIcon />,
      steps: BernabeuSteps,
    },
    {
      id: 9,
      name: "Sentimiento ciudadano",
      iframeSrc: "districts",
      lat: 40.430820658368916,
      lon: -3.695792922099286,
      height: 5605,
      icon: <PsychologyAltIcon />,
      steps: SentimientoSteps,
    },
    {
      id: 10,
      name: "Urbanismo",
      iframeSrc: "urbanismo",
      lat: 40.430820658368916,
      lon: -3.695792922099286,
      height: 5605,
      icon: <ApartmentIcon />,
      steps: UrbanismoSteps,
    },
  ];
  const ayuntamientoLogo = require("../assets/img/logo_ayuntamiento.png");
  const darkTheme = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: "#ffffff",
      },
    },
  });

  // Send message to iframe
  const sendMessageToIframe = (message) => {
    if (iframeRef.current) {
      const iframeElement = iframeRef.current;
      iframeElement.contentWindow?.postMessage(message, "*");
    }
  };

  // Listener from iframe
  const receiveMessage = (event) => {
    const data = event.data;

    if (data.type === "flyToCompleted") {
      if (!data.value) return;

      // open modal
      setModalOpen(true);
    }
  };
  window.addEventListener("message", receiveMessage);

  const handleClick = (useCase) => {
    // send message to iframe
    sendMessageToIframe({
      type: "flyTo",
      lat: useCase.lat,
      lon: useCase.lon,
      height: useCase.height,
      name: useCase.iframeSrc,
      duration: 10,
    });

    setUseCaseSelected(useCase);
    console.log(useCase);
  };

  const backToLanding = () => {
    return () => {
      setShowBackButton(false);
      setLateralWidth(250);
      setIframeSrc("map/index.html");
      // wait 1 second to show the iframe
      setTimeout(() => {
        sendMessageToIframe({
          type: "flyTo",
          lat: useCaseSelected.lat,
          lon: useCaseSelected.lon,
          height: useCaseSelected.height,
          name: null,
        });
        setUseCaseSelected(null);
      }, 1000);
    };
  };

  const tutorialCompletedCallback = () => {
    // show back button
    setShowBackButton(true);

    // close modal
    setModalOpen(false);

    // set iframe width to 0
    setLateralWidth(0);

    // set iframe src
    setIframeSrc(useCaseSelected.iframeSrc + "/index.html");
  };

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List>
        {useCases.map((useCase) => (
          <ListItem key={useCase.name} disablePadding>
            <ListItemButton onClick={() => handleClick(useCase)}>
              <ListItemIcon>{useCase.icon}</ListItemIcon>
              <ListItemText primary={useCase.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  const container =
    containerWindow !== undefined
      ? () => containerWindow().document.body
      : undefined;

  return (
    <ThemeProvider theme={darkTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${lateralWidth}px)` },
            ml: { sm: `${lateralWidth}px` },
          }}
        >
          <Toolbar>
            {showBackButton && (
              <Button
                type="primary"
                className="backButton"
                onClick={backToLanding()}
              >
                <ArrowBackIcon /> Volver
              </Button>
            )}
            <img src={ayuntamientoLogo} alt="logo" className="logo" />
            <Typography variant="h6" noWrap component="div">
              Digital Twin
            </Typography>
            <Stack
              justifyContent="center"
              alignItems="center"
              direction="row"
              spacing={2}
              className="userInfo"
            >
              <Avatar
                sx={{ bgcolor: "#ba7f61", height: 30, width: 30 }}
                alt={getUserInfo().name}
                className="avatar"
              >
                {getNameInitials()}
              </Avatar>
              <Button onClick={handleMenuClick}>{getUserInfo().name}</Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem disabled>Sesion ID: {getUserInfo().token}</MenuItem>
                <MenuItem onClick={logout}>
                  Logout
                  <LogoutIcon sx={{ marginLeft: 2 }} />
                </MenuItem>
              </Menu>
            </Stack>
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{ width: { sm: lateralWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: lateralWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: lateralWidth,
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box width="100%" height="100vh" display="flex" flexDirection="column">
          <Toolbar />
          <iframe
            title="main-iframe"
            id="mainIframe"
            src={iframeSrc}
            ref={iframeRef}
          />
          <Modal
            open={modalOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="modalBox">
              <HorizontalLinearStepper
                closeModelCallback={() => setModalOpen(false)}
                steps={useCaseSelected?.steps}
                tutorialCompletedCallback={tutorialCompletedCallback}
              />
            </Box>
          </Modal>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

Edv.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  containerWindow: PropTypes.func,
};

export default Edv;
